import { createTheme, styled } from '@mui/material/styles';
import { Radio, ListItem } from '@mui/material';


export const config = {
  apikey: 'J6rK$Ck5dcWD!G4#rdFBq$$%Ysv3jt#',
  tenant: 'WISR_PROD',
  tenantA: 'WISR-PROD',
  
};

export const logoURL = '/assets/wisrdashboard.png';
export const logoURLDashboard = '/assets/wisrdashboard.png';

export const theme = createTheme({
    palette: {
      primary: {
        main: '#BDDEE0',
     },
      background: {
        default: '#9EBFDE', // Set your desired background colour here
      },
      appbar: {
        default: '#ffffff', // Set your desired background colour here
      },
      switchColor: {
        main: '#BDDEE0',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#ffffff', // Ensure the body has the same background colour
          },
          secondary: {
            backgroundColor: '#9EBFDE', // Ensure the body has the same background colour
          },
          switch: {
            main: '#BDDEE0',
          }
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          root: {
            '&.Mui-active': {
              color: '#47b3b5',
            },
            '&.Mui-completed': {
              color: '#47b3b5',
            },
          },
        },
      },
  }});


 export const StyledRadio = styled(Radio)(({ theme }) => ({
    '&.Mui-checked': {
      color: '#47b3b5', // Custom color for checked state
    },
    '& .MuiSvgIcon-root': {
      fontSize: 24, // Adjust the size to match checkbox size
    },
  }));


  export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 6,
    p: 4,
  };

  export const CustomListItem = styled(ListItem)(({ theme }) => ({
    '&.Mui-selected': {
      backgroundColor: '#47b3b5',
      '&:hover': {
        backgroundColor: '#47b3b5',
      },
    },
  }));
  